import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { RsaEncryptionService } from './rsa-encryption.service';

@Injectable({
  providedIn: 'root'
})
export class AesEncryptionService {

  private iv: string = '@qwertyuiop12344';
  private key: string = '';
  constructor(private _rsa: RsaEncryptionService) { }

  aesKey(): string {
    this.key = this.randomKey(16);
    return this.key;
  }

  encrypt(valueToEncrypt: any, aesKey: string): string {
    const keyHex = CryptoJS.enc.Hex.parse(aesKey);
    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(valueToEncrypt), keyHex, {
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
      iv: CryptoJS.enc.Hex.parse('00000000000000000000000000000000')
    }).toString();
    return encrypted;
  }

  decrypt(encryptedData: string, key: string) {
    // console.log('encryptedData', encryptedData)
    // console.log('key', key)
    const keyHex = CryptoJS.enc.Hex.parse(key);

    // Decrypt the data
    const decryptedBytes = CryptoJS.AES.decrypt(encryptedData, keyHex, {
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
      iv: CryptoJS.enc.Hex.parse('00000000000000000000000000000000')
    });
    // Convert from bytes to UTF-8 string
    const decryptedText = decryptedBytes.toString(CryptoJS.enc.Utf8);
    // console.log(decryptedText)

    return JSON.parse(JSON.parse(decryptedText));
  }

  randomKey(length: number) {
    let result = CryptoJS.lib.WordArray.random(32)
    return result.toString();
  }
}
